import React, { useState } from 'react';
import ColumnMenu from './ColumnMenu';
import { GROUPABLE_TYPES } from '../../utils/projectView';
import { useLanguage } from '../../i18n/LanguageContext';

/**
 * Il menu di una colonna esistente con tutte le sue azioni, uguale in ogni vista (intestazione della tabella,
 * pannello Proprietà, board). Va messo dentro l'elemento a cui si ancora (l'intestazione o la riga).
 *  - onColumnAction(azione, colonna, extra): filtra, ordina, raggruppa, nascondi, duplica, elimina (le gestisce la pagina);
 *  - onColumnSubmit(colonna, payload, posizione): rinomina/modifica, oppure crea (colonna null) accanto a un'altra.
 * `initialView` ('main' | 'edit'): da dove parte il menu.
 */
function ColumnMenuHost({ column, initialView = 'main', onClose, onColumnSubmit, onColumnAction }) {
  const { t } = useLanguage();
  const [insertSide, setInsertSide] = useState(null); // 'left' | 'right': si sta creando una colonna accanto

  if (insertSide) {
    return (
      <ColumnMenu
        column={null}
        onClose={onClose}
        onSubmit={(payload) => { onClose(); onColumnSubmit(null, payload, { anchor: column.id, side: insertSide }); }}
      />
    );
  }

  const run = (action, extra) => () => { onClose(); onColumnAction(action, column, extra); };
  const actions = [
    { key: 'filter', icon: 'filter', label: t('projectView.menuFilter'), onClick: run('filter') },
    { key: 'asc', icon: 'arrowUp', label: t('projectView.menuAscending'), onClick: run('sort', 'asc') },
    { key: 'desc', icon: 'arrowDown', label: t('projectView.menuDescending'), onClick: run('sort', 'desc') },
  ];
  if (GROUPABLE_TYPES.includes(column.type)) {
    actions.push({ key: 'group', icon: 'groupBy', label: t('projectView.menuGroup'), onClick: run('group') });
  }
  if (column.type !== 'title') {
    actions.push(
      { key: 'hide', icon: 'eyeoff', label: t('projectView.menuHide'), onClick: run('hide') },
      { key: 'insertLeft', icon: 'insertLeft', label: t('projectView.menuInsertLeft'), onClick: () => setInsertSide('left') },
    );
  }
  actions.push({ key: 'insertRight', icon: 'insertRight', label: t('projectView.menuInsertRight'), onClick: () => setInsertSide('right') });
  if (column.type !== 'title') {
    actions.push(
      { key: 'dup', icon: 'copy', label: t('projectView.menuDuplicate'), onClick: run('duplicate') },
      { key: 'del', icon: 'trash', label: t('projectView.menuDelete'), onClick: run('delete') },
    );
  }

  return (
    <ColumnMenu
      column={column}
      actions={actions}
      initialView={initialView}
      onClose={onClose}
      onSubmit={(payload) => { onClose(); onColumnSubmit(column, payload); }}
    />
  );
}

export default ColumnMenuHost;
